import React, { useState } from "react";

// positioned by dropdown.css

function Dropdown(props) {
	const { title, list, selectItem } = props;
	const [ listOpen, setListOpen ] = useState(false);
	
	const toggleList = () => {
		setListOpen( prevState => !prevState );
	}

	const updateSelection = (item) => {
		selectItem(item);
		toggleList();
	}
	
	return (
		<div className="dd-wrapper">
			<div className="dd-header" onClick={() => toggleList()}>
				<div className="dd-header-title">{title}</div>
			</div>
			{listOpen && 
				<ul className="dd-list">	
					{list.map((item, id) => (
						<li className="dd-list-item" key={id} onClick={() => updateSelection(item)}> {item}</li>
					))}
				</ul>
			}
		</div>
	)
}

export default function ListMenu(props) {
	const { selected, list, title } = props;
	return (
		<div className="dd-container">
			<Dropdown
				title={title}
        	    list={list}
            	selectItem={selected}
			/>
		</div>
	)
}